/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-menu': {
    width: 16,
    height: 12,
    viewBox: '0 0 16 12',
    data: '<rect pid="0" x=".188" y=".582" width="15.688" height="2.144" rx="1.072" _fill="#fff"/><rect pid="1" x=".188" y="4.928" width="15.688" height="2.144" rx="1.072" _fill="#fff"/><rect pid="2" x=".188" y="9.274" width="10.28" height="2.144" rx="1.072" _fill="#fff"/>'
  }
})
